export function getScriptedFlowBlockDefaultConfig() {
  return {
    fn: `return Math.floor(Math.random() * 64);
`,
  };
}
